import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-pawn",
  "use": "icon-si-glyph-pawn-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-pawn\" id=\"icon-si-glyph-pawn\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>1044</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M3,16 L15,16 L12,12 L12,5 L14,3 L14,0 L12.062,0 L12.062,1 L9.937,1 L9.937,0 L8.062,0 L8.062,1 L5.937,1 L5.937,0 L4,0 L4,3 L6,5 L6,12 L3,16 L3,16 Z M10,5 L11,5 L11,12 L10,12 L10,5 L10,5 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-pawn.svg
// module id = MWzt
// module chunks = 62